import React from "react";
import "../../App.css";

const Spinner = () => {
  return (
    // <div className="spnner">
    //   <div className="lds-ring">
    //     <div></div>
    //     <div></div>
    //     <div></div>
    //     <div></div>
    //   </div>
    // </div>
    <div className="flex justify-center items-center h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>
  );
};

export default Spinner;
